import React, { memo } from 'react';

import { Avatar, AvatarGroup, useTheme } from '@mui/material';
import TooltipWrapper from 'app/shared/components/common/TooltipWrapper';
import PropTypes from 'prop-types';

import { getPersonInitials } from 'utils/loanApplication';

import AssignedUserCard from './UserCard';
import { userPropTypes } from './UserCard/UserCard.constants';
import { getStyles, tooltipStyles } from './UsersAvatarGroup.styles';

const UsersAvatarGroup = ({ usersData, maxAvatars = 6, withUserCard = false }) => {
  const theme = useTheme();
  const classes = getStyles(theme, { isActive: false, maxAvatars });

  return (
    <AvatarGroup max={maxAvatars} spacing={0} sx={classes.wrapper}>
      {usersData.map(user => {
        const { firstName, lastName } = user;
        const initials = getPersonInitials({ firstName, lastName });

        const content = <Avatar key={firstName + lastName}>{initials}</Avatar>;

        if (!withUserCard) {
          return content;
        }

        const TooltipContent = <AssignedUserCard userData={user} />;

        return (
          <TooltipWrapper
            key={firstName + lastName}
            title={TooltipContent}
            tooltipSx={tooltipStyles}
          >
            <Avatar>{initials}</Avatar>
          </TooltipWrapper>
        );
      })}
    </AvatarGroup>
  );
};

UsersAvatarGroup.propTypes = {
  usersData: PropTypes.arrayOf(PropTypes.shape(userPropTypes)).isRequired,
  maxAvatars: PropTypes.number,
  withUserCard: PropTypes.bool,
};

export default memo(UsersAvatarGroup);
